export default __webpack_public_path__ + "static/media/IMG_1654.390ebf47.jpg";